<flx-resources-grid
  [tableDef]="exceptionsTableColumns"
  [inputGridOptions]="gridOptions()"
  (gridReady)="onGridReady($event)"
  emptyMsg="No exceptions found."
></flx-resources-grid>

<div *flxShowModal="retryInProgress$ | async">
  <flx-spinner
    [radius]="90"
    size="custom"
    visualType="custom"
  ></flx-spinner>
</div>

<ng-template
  [flxShowModal]="showDetailsModal()"
  panelClass="w-[80%] h-[90%]"
>
  <flx-exception-details-modal
    [exceptionId]="selectedExceptionInstance().id"
    (hideModal)="hideDetailsModal()"
    class="w-full h-full"
  ></flx-exception-details-modal>
</ng-template>
